<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">
    <dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
      (onEditorPreparing)="onEditorPreparing($event)">

      <!-- Definición de las columnas -->
      <dxi-column dataField="appId" caption="Código de App" alignment="center"></dxi-column>
      <dxi-column *ngIf="this.conectiaLicence" dataField="companyCode" caption="Código Innuva"
        alignment="center"></dxi-column>
      <dxi-column dataField="name" caption="Nombre" alignment="center"></dxi-column>
      <dxi-column dataField="enabled" caption="Habilitado" alignment="center"
        [calculateCellValue]="transformBooleanToYesNo"></dxi-column>

      <!-- Templates -->
      <ng-container *ngIf="isCrud">
        <dxi-column dataField="company1" caption="Acciones" [allowFiltering]="false" [allowSorting]="false"
          alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
        <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
          <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onClickEdit(data.value)">
            <i class="material-icons">edit</i>
          </button>
          <button rel="tooltip" type="button" class="btn btn-action"
            [ngClass]="data.data.enabled ? 'btn-primary' : 'btn-default'" (click)="onClickDisable(data)"
            *ngIf="isAdmin()">
            <ng-container *ngIf="data.data.enabled; else disabledIcon">
              <i class="material-icons">toggle_on</i>
            </ng-container>
            <ng-template #disabledIcon>
              <i class="material-icons">toggle_off</i>
            </ng-template>
          </button>

        </ng-container>
      </ng-container>

      <!-- Añadir nuevos -->
      <div *dxTemplate="let data of 'addNew'">
        <button class="btn btn-success btn-sm btn-accept btn-blue ml-2" style="padding-inline: 10px;"
          (click)="onClickAdd()" *ngIf="isAdmin()">
          <i class="material-icons icon-centered mr-2" style=" scale: 1.2; ">add</i>
          <span class="d-none d-sm-inline-block" style=" scale: 1.05; ">Nuevo</span>
        </button>
        <button *ngIf="!conectiaLicence" class="btn btn-success btn-sm btn-accept btn-blue ml-2"
          style="padding-inline: 10px;" (click)="onClickImport()">
          <i class="material-icons icon-centered mr-2" style=" scale: 1.2; ">add</i>
          <span class="d-none d-sm-inline-block" style=" scale: 1.05; ">Importar</span>
        </button>
      </div>
    </dx-data-grid>

  </app-generic-panel>

  <br>
</app-generic-container>